import { Link } from "react-router-dom";
import { format } from "date-fns";
import { useArticles } from "../lib/articles";
import { SiteHeader } from "../components/platform/PlatformChrome";
import { Footer } from "../components/landing/Footer";

export default function PublicNews() {
  const q = useArticles({ limit: 30 });
  const articles = q.data?.articles ?? [];

  return (
    <>
      <SiteHeader />
      <main className="pt-32 pb-24">
        <div className="container-edit max-w-[1100px]">
          <header className="mb-14">
            <p className="eyebrow mb-3">News &amp; Reflections</p>
            <h1 className="font-display text-[clamp(2.5rem,6vw,4.25rem)] leading-[1.04] tracking-[-0.02em]">
              Words from the{" "}
              <span className="font-display-italic" style={{ color: "var(--color-violet)" }}>
                circle
              </span>
              .
            </h1>
            <p className="text-[1.1rem] text-[var(--color-ink-soft)] max-w-[55ch] mt-5">
              Editorial pieces, scripture studies, festival recaps, and
              announcements from the Veda Union community.
            </p>
          </header>

          {articles.length === 0 ? (
            <p className="font-display-italic text-[1.2rem] text-[var(--color-ink-mute)]">
              No articles yet — check back soon.
            </p>
          ) : (
            <ul className="flex flex-col">
              {articles.map((a, idx) => (
                <li
                  key={a.id}
                  className="grid grid-cols-1 md:grid-cols-[180px_1fr] gap-4 md:gap-8 py-9 border-t border-[var(--color-rule)]"
                  style={idx === 0 ? { borderTop: "none", paddingTop: 0 } : undefined}
                >
                  <div>
                    <p className="font-grotesk text-[0.7rem] tracking-[0.18em] uppercase text-[var(--color-violet)] mb-2">
                      {a.category.replace(/-/g, " ")}
                    </p>
                    <p className="font-display-italic text-[1rem] text-[var(--color-ink-mute)]">
                      {a.publishedAt ? format(new Date(a.publishedAt), "d LLLL yyyy") : ""}
                    </p>
                    {a.featured && (
                      <p className="font-grotesk text-[0.65rem] tracking-[0.18em] uppercase text-[var(--color-gold)] mt-2">
                        Featured
                      </p>
                    )}
                  </div>
                  <div>
                    <Link
                      to={`/news/${a.slug}`}
                      className="block group"
                    >
                      {a.coverImage && (
                        <img
                          src={a.coverImage}
                          alt=""
                          className="w-full h-52 object-cover mb-5"
                        />
                      )}
                      <h2 className="font-display text-[clamp(1.7rem,3.5vw,2.4rem)] leading-[1.1] tracking-[-0.01em] group-hover:text-[var(--color-violet)] transition-colors">
                        {a.title}
                      </h2>
                      {a.subtitle && (
                        <p className="font-display-italic text-[1.15rem] text-[var(--color-ink-mute)] mt-2">
                          {a.subtitle}
                        </p>
                      )}
                      {a.excerpt && (
                        <p className="text-[1.05rem] leading-[1.55] text-[var(--color-ink-soft)] max-w-[60ch] mt-4">
                          {a.excerpt}
                        </p>
                      )}
                    </Link>
                    {a.authorName && (
                      <p className="font-grotesk text-[0.7rem] tracking-[0.16em] uppercase text-[var(--color-ink-mute)] mt-4">
                        By {a.authorName}
                      </p>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}
